import React, { useState } from "react";
import { Box, DialogContent, Grid, Tooltip, Typography } from "@mui/material";
import { DatePickerComponent, RadioButtonComponent } from "../../atom";
import moment from "moment";
import { THEME_COLORS } from "../../../core/Constant";

const PlanSelectionDialog = ({
  plans = [],
  selectedPlan = "",
  onPlanChange,
  planExpiryDate = "",
  handleExpiryDateChange,
  planExpiryDateError = ""
}) => {

  const handleChange = (e) => {
    const selectedP = e?.target?.value;
    onPlanChange(selectedP);
  };

  return (
    <DialogContent>
      <Grid container>
        <Grid item xs={12}>
        {plans?.map((plan) => {
          const planName = plan?.plan_name || "";
          const needsTooltip = planName?.length > 40;
          const displayedText = needsTooltip
            ? `${planName?.substring(0, 40)}...`
            : planName;
          return (
            <Box>
              <Box display={"flex"} alignItems={"center"}>
                <RadioButtonComponent
                  checked={plan?.id?.toString() === selectedPlan.toString()}
                  selectedValue={
                    plan?.id?.toString() === selectedPlan?.toString()
                  }
                  value={plan?.id}
                  handleChange={handleChange}
                />
                <Box>
                  <span
                    style={{
                      fontFamily: "Montserrat, sans serif",
                      fontSize: "15px",
                      padding: 0,
                      margin: 0,
                      marginRight: 5,
                      color: "#2d3945",
                    }}
                  >
                    {needsTooltip ? (
                      <Tooltip title={planName} placement="top" arrow>
                        <span style={{ cursor: "pointer" }}>
                          {displayedText}
                        </span>
                      </Tooltip>
                    ) : (
                      displayedText
                    )}
                  </span>

                  <span
                    style={{
                      fontFamily: "Montserrat",
                      fontWeight: 800,
                      fontSize: 15,
                      color: "#2d3945",
                    }}
                  >
                    {planName ? " -" : ""}
                    {` ${
                      plan?.batch_month
                        ? moment()
                            .month(Number(plan?.batch_month) - 1)
                            .format("MMMM")
                        : ""
                    } ${plan?.batch_year ? plan?.batch_year : ""}`}
                  </span>
                </Box>
              </Box>
            </Box>
          );
        })}
        </Grid>
        <Grid item xs={12} mt={2} pr={1} pl={1}>
            <Typography
               color={THEME_COLORS.gray3}
               fontWeight={700}
               fontSize={16}
               pb={1}
             >  
              Expiry Date
              <span style={{ color: "#d06060", marginLeft: 2, fontSize:19 }}>
                *
             </span>
            </Typography>
            <DatePickerComponent
              containeStyle={{
                padding: 0,
              }}
              dateFormat="dd/MM/yyyy"
              minDate={moment().startOf("day").toDate()}
              selected={
                planExpiryDate &&
                moment(planExpiryDate, "YYYY-MM-DD", true).isValid()
                  ? moment(planExpiryDate, "YYYY-MM-DD").toDate()
                  : null
              }
              onChange={(date) => {
                handleExpiryDateChange(date ? moment(date).format("YYYY-MM-DD") : "")
              }}
              isError={Boolean(planExpiryDateError)}
              error={planExpiryDateError}
            />
          </Grid>
      </Grid>
      
    </DialogContent>
  );
};

export default PlanSelectionDialog;
